import { ModalScreenProps, ModalScreens } from 'components/Navigation/types';
import { NavigationHeader } from 'components/NavigationHeader';
import { PageScrollView } from 'components/Page';
import React from 'react';
import { useDispatch } from 'react-redux';
import { NAVIGATE_MODAL_BACK } from 'store/actions';
import { ExplorerOptions } from './ExplorerOptions';

export const ExplorerOptionsModal: React.FC<
  ModalScreenProps<ModalScreens.ASEEXPLOREROPTIONS>
> = () => {
  const dispatch = useDispatch();
  return (
    <PageScrollView
      header={
        <NavigationHeader
          heading="View Options"
          onPressSaveButton={() => dispatch(NAVIGATE_MODAL_BACK())}
          saveButtonText="Done"
        />
      }
    >
      <ExplorerOptions />
    </PageScrollView>
  );
};
